import React from 'react';
import { useNavigate } from 'react-router';
import { Button } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { strings } from '../../lang';
import { Header } from '../header/header';
import './not-found-page.css';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToBooking = () => {
    navigate('/booking');
  };

  return (
    <div className="not-found-page">
      <Header />
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="not-found-logo">
            <img src="/enpal-logo.png" alt="Enpal Logo" className="enpal-logo" />
          </div>
          <div className="not-found-text">
            <h1 className="not-found-title">{strings.pageNotFound.title}</h1>
            <p className="not-found-message">{strings.pageNotFound.message}</p>
            <Button 
              type="primary" 
              icon={<HomeOutlined />} 
              onClick={handleGoToBooking}
              size="large"
              className="go-home-button"
            >
              {strings.pageNotFound.goToBooking}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
